<div class="col-sm-12 no-padding">
  <div class="accordion" id="accordion2">
    <div class="accordion-group">
      <div class="accordion-heading">
        <button (click)="toggleAccordion()" class="accordion-toggle btn btn-link btn-block clearfix accordion-btn" data-toggle="collapse" data-parent="#accordion2" href="#collapseOne">
          <div class="row">
            <div class="pull-left font-weight-light bp-text bp-small-text col-md-8 text-align-left no-padding"><i class="fas arrowdiv-flow arrowdiv fa-chevron-right"></i> FLOW ALERTS</div>
            <div *ngIf="textSubscribed || emailSubscribed" class="col-md-4 green text-align-right">Subscribed</div>
            <div *ngIf="!textSubscribed && !emailSubscribed" class="col-md-4"></div>
          </div>
        </button>
      </div>
      <div id="collapseOne" class="accordion-body collapse">
        <div class="row">
          <div class="col-sm-12 no-padding">
            <p class="text-align-left title-small font-weight-light bp-text bp-x-small-text">
              This alert covers four different categories of possible alerts, Back Flow (meaning water is flowing in reverse), Continuouse Flow (meaning water is continuously flowing), No Flow (meaning there has been no water flow for a while), and Excessive Flow (meaning water flow is flowing more than average).
            </p>
          </div>
        </div>
        <div class="accordion-inner">
          <div *ngIf="!subscribed" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <button type="button" class="btn btn-light bp-text bp-medium-text" style="font-weight: 600;color: #3F8F8B;" (click)="onSubscribeClick()">+ SUBSCRIBE</button>
            </div>
          </div>
          <div *ngIf="subscribed" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><span class="bp-text bp-small-text">Contact Type:</span></div>
              <div class="col-sm-12">
                <div class="btn-group">
                  <label class="btn btn-primary subscription-container" (click)="showEmailInput()"
                         btnRadio="email" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="far fa-envelope"></i>Email</label>
                  <!--<label class="btn btn-primary subscription-container" (click)="showPhoneSelect()"
                         btnRadio="text" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="fas fa-mobile-alt"></i>Text</label>-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12"><span style="float:left;" class="bp-text bp-small-text">Destination:</span></div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12 bp-text bp-small-text">
                <div *ngIf="showPhone" class="form-group">
                  <span>
                    <select class="form-control select-medium" name="phone" [(ngModel)]="accountPhone">
                      <option *ngFor="let phone of accountPhones" [value]="phone">{{ phone }}</option>
                    </select>
                  </span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="textSubscribed"> (Text Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="textSubscribed" (click)="removeFlowAlert(true, false)" value="Remove Text Alerts" />
                  </div>
                </div>
                <div *ngIf="showEmail">
                  <span class="bp-text bp-bold-text" *ngIf="showEmail">{{accountEmail}}</span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="emailSubscribed"> (Email Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="emailSubscribed" (click)="removeFlowAlert(false, true)" value="Remove Email Alerts" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row bp-text bp-small-text" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><button (click)="onSaveFlowAlertClick()" class="btn btn-primary" type="button">SAVE</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/flow-alerts/flow-alerts.component.html